import React, { FunctionComponent } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import ratmCrud from "../../utils/RATMCrud"
import ratmService from "../../utils/RATMService"
import "./TemplateManagementDeleteTemplate.css"

const TemplateManagementDeleteTemplate: FunctionComponent<{}> = () => {

    const { deletePortalTemplates } = ratmCrud
    const { state, manageState } = ratmService
    const { deleteTemplateId, busyId } = state

    return (
        <div className="TemplateManagementDeleteTemplate">
            <Modal
                id="f1bd7ec20ce4bbf9a5c1335637dda3c"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="sm"
            >
                <Modal.Header>
                    <div className="TemplateManagementDeleteTemplateModalHeader">
                        <span className="material-icons">warning</span>
                        <p>Please confirm</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="TemplateManagementDeleteTemplateModalModalBody">
                        <p>Are you sure you want to delete this template?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="TemplateManagementDeleteTemplateModalModalFooter">
                        <Button variant="secondary" onClick={() => manageState([{ key: "deleteTemplateId", value: -1 }])}>Back</Button>
                        {
                            busyId !== 4 &&
                            <Button variant="danger" onClick={() => deletePortalTemplates([deleteTemplateId])}>Delete</Button>
                        }
                        {
                            busyId === 4 &&
                            <Spinner className="fc5773659914f0f94dbaebcf0a3ce56" animation="border" />
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default TemplateManagementDeleteTemplate